"use strict";
var meta_service_1 = require("./meta.service");
exports.MetaService = meta_service_1.MetaService;
var meta_module_1 = require("./meta.module");
exports.MetaModule = meta_module_1.MetaModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-meta/dist/index.js
// module id = 64
// module chunks = 0